import { TopicGroup } from '~/landingV4/types/topics.types'

export const topicGroups: TopicGroup[] = [
  {
    badgeKey: 'v4.topics.elementaryBadge',
    pillsKey: 'v4.topics.elementaryPills',
    badgeClass: 'bg-blue-blueberry',
  },
  {
    badgeKey: 'v4.topics.highSchoolBadge',
    pillsKey: 'v4.topics.highSchoolPills',
    badgeClass: 'bg-purple-violet-600',
  },
]
